export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_kr-18c7018957c482cce01090d7ec6e2388.png";